
import { defineComponent, PropType } from 'vue'

import IssueDetailMixin from '~/mixins/issueDetailMixin'

import { getSilenceRuleError, UiIssueLevel } from '~/utils/issue'
import { prCopyText } from '~/utils/ui'

export default defineComponent({
  name: 'IgnoreIssueAllFiles',
  mixins: [IssueDetailMixin],
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    checkId: {
      type: String,
      required: false
    },
    shortcode: {
      type: String,
      required: false
    },
    issueLevel: {
      type: String as PropType<UiIssueLevel>,
      default: UiIssueLevel.Repository
    },
    providerShortcode: {
      type: String as PropType<string | null>,
      default: null
    },
    repositoryId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    UiIssueLevel() {
      return UiIssueLevel
    },
    issueShortcode(): string {
      return this.shortcode ?? this.issue.shortcode ?? this.singleIssue.shortcode
    },
    computedProviderShortcode() {
      const routeMeta = this.$providerMetaMap[this.$route.params.provider]
      return this.providerShortcode ?? routeMeta?.shortcode ?? null
    },
    issueLevelCopy() {
      return this.issueLevel === UiIssueLevel.Repository
        ? 'repository'
        : this.issueLevel === UiIssueLevel.Check
          ? prCopyText(this.computedProviderShortcode)
          : ''
    }
  },
  methods: {
    close(): void {
      this.$emit('close')
    },
    async confirm(): Promise<void> {
      const params = {} as {
        repositoryId?: string
        checkId?: string
        issueShortcode?: string
      }

      if (this.checkId) {
        params.checkId = this.checkId
        params.issueShortcode = this.issueShortcode
      } else {
        params.repositoryId = this.repositoryId
        params.issueShortcode = this.issueShortcode
      }

      this.isLoading = true

      try {
        const response = await this.ignoreIssueRepository(params)
        this.$toast.success(`${this.issueShortcode} ignored for all files in this repository.`)

        this.$emit('ignore', response.checkIssueIds)
      } catch (e) {
        const silenceRuleMsg = getSilenceRuleError(e)
        if (silenceRuleMsg) {
          this.$toast.danger(silenceRuleMsg)
        } else {
          this.$logErrorAndToast(
            e as Error,
            'Something went wrong while ignoring this issue, please contact support.',
            undefined,
            {
              context: 'Ignore Issue',
              params: {
                method: 'Ignore Issue All Files',
                ...params
              }
            }
          )
        }
      } finally {
        this.isLoading = false
      }
    }
  }
})
